import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InputMask from "react-input-mask";
import moment from "moment";
import React from "react";

const CustomDatePicker = (props) => {
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  console.log("props.minDate",props.minDate);
  

  const handleChange = (date) => {
    if (props.readOnly) return; // Prevent changes when readOnly
    
    props.handleChange({
      target: { 
        name: props.name, 
        value: date ? moment(date).format("DD-MMM-YYYY") : ""
      }
    });
  };

  // Convert empty string to null for the selected value
  // const getSelectedValue = () => {

  //   if (!props.value || props.value.trim() === "") return null;

  //   return moment(props.value, "DD-MMM-YYYY").isValid()

  //     ? moment(props.value, "DD-MMM-YYYY").toDate()

  //     : null;

  // };
  // const getSelectedValue = () => {
  //   if (!props.value || props.value.trim() === "") return null;
  //   return moment(props.value).format("DD-MMM-YYYY")
  //     ? moment(props.value).format("DD-MMM-YYYY")
  //     : null;
  // };

  const getSelectedValue = () => {
    if (!props.value || props.value.trim() === "") return null;
  
    const possibleFormats = [
      "DD-MMM-YYYY", 
      "YYYY-MM-DD", 
      "DD-MM-YYYY", 
      "MM/DD/YYYY", 
      "DD/MM/YYYY", 
      "MMM DD, YYYY", 
      moment.ISO_8601
    ];
  
    const date = moment(props.value, possibleFormats, true);
    return date.isValid() ? date.toDate() : null;
  };
  
  const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <div style={{ 
      display: 'flex', 
      width: '100%',
      position: 'relative',
      opacity: props.readOnly ? 0.7 : 1
    }}>
      <InputMask
        mask="99-aaa-9999"
        maskChar={null}
        style={{
          width: '100%',
          padding: '0.375rem 2.5rem 0.375rem 0.75rem',
          fontSize: '1rem',
          lineHeight: 1.5,
          color: props.readOnly ? '#6c757d' : '#495057',
          backgroundColor: props.readOnly ? '#e9ecef' : '#fff',
          border: '1px solid #ced4da',
          borderRadius: '0.25rem',
          transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
          outline: 'none',
          cursor: props.readOnly ? 'not-allowed' : 'text'
        }}
        onClick={(e) => {
          if (!props.readOnly) {
            onClick(e);
          }
        }}
        ref={ref}
        value={value || ''}
        readOnly={props.readOnly}
        placeholder={props.placeholderText}
        disabled={props.readOnly}
      />
      <div 
        style={{
          position: 'absolute',
          right: '0.75rem',
          top: '50%',
          transform: 'translateY(-50%)',
          cursor: props.readOnly ? 'not-allowed' : 'pointer',
          color: props.readOnly ? '#adb5bd' : '#6c757d',
          fontSize: '1rem',
          backgroundColor: 'transparent',
          border: 'none',
          padding: '0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '1.5rem',
          height: '1.5rem',
          pointerEvents: props.readOnly ? 'none' : 'auto'
        }}
        onClick={(e) => {
          if (!props.readOnly) {
            if (value) {
              e.stopPropagation();
              handleChange(null);
            } else {
              onClick(e);
            }
          }
        }}
      >
        {value ? '×' : '📅'}
      </div>
    </div>
  ));

  return (
    <DatePicker
      selected={getSelectedValue()}
      onChange={handleChange}
      customInput={<CustomInput />}
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div className="input-group input-group-sm input-group-calender">
          <div className="input-group-prepend">
            <button
              onClick={(e) => {
                e.preventDefault();
                decreaseMonth();
              }}
              disabled={prevMonthButtonDisabled || props.readOnly}
              className="btn btn-outline-secondary"
              type="button"
            >
              {"<"}
            </button>
          </div>

          {/* Month Dropdown */}
          <select
            className="form-control disable"
            value={months[date.getMonth()]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
            disabled={props.readOnly}
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          {/* Year Dropdown */}
          <select
            className="form-control"
            value={date.getFullYear()}
            onChange={({ target: { value } }) => changeYear(value)}
            disabled={props.readOnly}
          >
            {Array.from(new Array(100), (v, i) => (
              <option key={i} value={i + (date.getFullYear() - 85)}>
                {i + (date.getFullYear() - 85)}
              </option>
            ))}
          </select>

          <div className="input-group-append">
            <button
              onClick={(e) => {
                e.preventDefault();
                increaseMonth();
              }}
              className="btn btn-outline-secondary"
              disabled={nextMonthButtonDisabled || props.readOnly}
            >
              {">"}
            </button>
          </div>
        </div>
      )}
      wrapperClassName={props.wrapperClassName}
      placeholderText={props.placeholderText}
      maxDate={props.maxDate}
      minDate={props.minDate}

      id={props.id}
      name={props.name}
      readOnly={props.readOnly}
      disabled={props.readOnly}
      dateFormat="dd-MMM-yyyy"
      showPopperArrow={false}
      popperClassName="react-datepicker-popper"
    />
  );
};

export default CustomDatePicker;